export enum OrderState {
  NONE,
  MODIFY_ACCEPTANCE_NEEDED,
  CANCEL_ACCEPTANCE_NEEDED,
  IN_MODIFICATION,
  MANUAL_PRICING,
  DELETED,
  PENDING,
  PRICED,
  SAVED,
  ACTIVE,
  FILLED,
  CANCELLED,
  EXPIRED,
  TRIGGERED,
  CREDIT_CHECKING,
  DI_NEEDED,
  ACCEPTANCE_NEEDED,
  REJECTED,
  PRICING,
  FILL_ERROR,
  FILL_EXPIRED,
  PENDING_CANCELLATION,
  DI_APPROVED,
  GAMMA_MID_PENDING,
  MIGRATION_ACCEPTANCE_NEEDED,
  ENTRYPRICING,
  SUSPENDED,
  EXPIRY_ACCEPTANCE_NEEDED,
  TRIGGERED_EXPIRY_ACCEPTANCE_NEEDED,
  REQUESTED,
  TRADER_REJECTED,
  SALES_REJECTED,
  CLIENT_REJECTED,
  ABORTED,
  ACCEPTED,
  BOOK_PENDING,
  DONE,
  CREDIT_PENDING,
  PRICE_PENDING,
  TIMED_OUT,
  MATCHED,
  FILLING,
  EXT_ACCEPTANCE_NEEDED,
  EXT_MODIFY_ACCEPTANCE_NEEDED,
  EXT_CANCEL_ACCEPTANCE_NEEDED,
  FILL_PENDING,
  PENDING_FWDS,
  EXPIRY_PENDING_FWDS,
  CANCEL_PENDING_FWDS,
}

export namespace OrderState {
  let elements = [
    OrderState.NONE,
    OrderState.MODIFY_ACCEPTANCE_NEEDED,
    OrderState.CANCEL_ACCEPTANCE_NEEDED,
    OrderState.IN_MODIFICATION,
    OrderState.MANUAL_PRICING,
    OrderState.DELETED,
    OrderState.PENDING,
    OrderState.PRICED,
    OrderState.SAVED,
    OrderState.ACTIVE,
    OrderState.FILLED,
    OrderState.CANCELLED,
    OrderState.EXPIRED,
    OrderState.TRIGGERED,
    OrderState.CREDIT_CHECKING,
    OrderState.DI_NEEDED,
    OrderState.ACCEPTANCE_NEEDED,
    OrderState.REJECTED,
    OrderState.PRICING,
    OrderState.FILL_ERROR,
    OrderState.FILL_EXPIRED,
    OrderState.PENDING_CANCELLATION,
    OrderState.DI_APPROVED,
    OrderState.GAMMA_MID_PENDING,
    OrderState.MIGRATION_ACCEPTANCE_NEEDED,
    OrderState.ENTRYPRICING,
    OrderState.SUSPENDED,
    OrderState.EXPIRY_ACCEPTANCE_NEEDED,
    OrderState.TRIGGERED_EXPIRY_ACCEPTANCE_NEEDED,
    OrderState.REQUESTED,
    OrderState.TRADER_REJECTED,
    OrderState.SALES_REJECTED,
    OrderState.CLIENT_REJECTED,
    OrderState.ABORTED,
    OrderState.ACCEPTED,
    OrderState.BOOK_PENDING,
    OrderState.DONE,
    OrderState.CREDIT_PENDING,
    OrderState.PRICE_PENDING,
    OrderState.TIMED_OUT,
    OrderState.MATCHED,
    OrderState.FILLING,
    OrderState.EXT_ACCEPTANCE_NEEDED,
    OrderState.EXT_MODIFY_ACCEPTANCE_NEEDED,
    OrderState.EXT_CANCEL_ACCEPTANCE_NEEDED,
    OrderState.FILL_PENDING,
    OrderState.PENDING_FWDS,
    OrderState.EXPIRY_PENDING_FWDS,
    OrderState.CANCEL_PENDING_FWDS,
  ];
  let alias = "com.bcdfx.api.model.OrderState";

  export function RemoteClass() {
    return alias;
  }

  export function getAllElements() {
    return elements;
  }
}
